import routeNames from "../router/route-names";
export default {
  DEFAULT_SCREEN: {
    name: routeNames.WALLET,
    path: "/",
  },
  GENDERS: ["MALE", "FEMALE"],
  PAYMENT_METHODS: {
    PAYLANDS: {
      name: "Card",
      key: "PAYLANDS",
    },
    MERCADOPAGO: {
      name: "Mercado Pago",
      key: "MERCADOPAGO",
    },
    MIT: {
      name: "Centro de pagos MIT",
      key: "MIT",
    },
    PVS: {
      name: "Tarjeta PVS",
      key: "PVS",
    },
  },
  SIGN_UP_FIELDS: {
    locator: {
      locator: null,
      email: null,
      authToken: null
    },
    tag: {
      tag: null,
      email: null,
      authToken: null
    },
    no_reference: {
      email: null,
      authToken: null
    },
  },
};
